export default "__VITE_ASSET__D_Fi9URL__"